import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import { Job, Proposal } from "generated/graphql";
import formatCentsToUSD from "utils/money/formatCentsToUSD";
import ChangeOrderActionsCell from "./ChangeOrderActionsCell";
import MDTypography from "components/MDTypography";
import CreateChangeOrder from "../buttons/CreateChangeOrder/CreateChangeOrder";
import MDBox from "components/MDBox";

export default function ChangeOrders({
  proposal,
  changeOrders,
  jobId,
}: {
  proposal?: Proposal;
  changeOrders?: Job["changeOrders"];
  jobId?: Job["id"];
}) {
  const changeOrdersField = changeOrders || proposal.changeOrders;
  return (
    <>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MDTypography variant="h5">Change Orders</MDTypography>
        <CreateChangeOrder
          isChangeOrder={proposal.isChangeOrder}
          status={proposal.status}
          id={proposal.id}
          changeOrderJobId={jobId}
        />
      </MDBox>
      <TableContainer component={Paper}>
        <Table
          size="small"
          sx={{
            [`& .${tableCellClasses.head}`]: {
              backgroundColor: "#666",
              color: "#fff",
            },
            [`& .${tableCellClasses.body}`]: {
              fontSize: 14,
            },
            maxWidth: "100%",
          }}
        >
          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {changeOrdersField &&
              changeOrdersField.map((changeOrder) => (
                <TableRow key={changeOrder.id}>
                  <TableCell>{changeOrder.externalIdWithPrefix}</TableCell>
                  <TableCell>{changeOrder.status}</TableCell>
                  <TableCell>{formatCentsToUSD(changeOrder.overallTotalAfterTaxes)}</TableCell>
                  <TableCell>
                    <ChangeOrderActionsCell row={{ values: changeOrder }} />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
